import { render, staticRenderFns } from "./ViewDetailsHistoryModal.vue?vue&type=template&id=c0049f42&scoped=true&"
import script from "./ViewDetailsHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./ViewDetailsHistoryModal.vue?vue&type=script&lang=ts&"
import style0 from "./ViewDetailsHistoryModal.vue?vue&type=style&index=0&id=c0049f42&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0049f42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VSpacer})
